<template>
    <e-message
        v-if="attemptAuthorizations.length > 0"
        type="is-warning"
        size="is-small"
        icon="pi pi-key"
        has-icon
    >
        You have {{ attemptAuthorizations.length }} authorization
        {{ translate('attempt', attemptAuthorizations.length) }} to use for this activity

        <span v-if="noneExpiring">
            and {{ translate('it_or_they', attemptAuthorizations.length) }} will not expire.
        </span>

        <span v-else>
            <span v-if="attemptAuthorizations.length > 1"> and the soonest </span>
            <span v-else> and it </span>
            will expire on
            {{ soonestExpiring.timestamp('expires_at').format('ddd, LLL zz') }}.
        </span>
    </e-message>
    <e-message
        v-else-if="hasSubmittedFile && hasAttemptAuthorization"
        type="is-notice"
        size="is-small"
        icon="pi pi-key"
        has-icon
    >
        You have used all of your attempt authorizations for this activity and have none remaining.
    </e-message>
</template>

<script>
import { useI18n } from 'vue-i18n';

export default {
    setup() {
        const { t: translate } = useI18n();
        return { translate };
    },
    name: 'AttemptAuthorizationNotice',

    props: {
        attemptAuthorizations: {
            type: Array,
            required: true,
        },
        hasSubmittedFile: {
            type: Boolean,
            default: false,
        },
        hasAttemptAuthorization: {
            type: Boolean,
            default: false,
        },
    },

    computed: {
        message() {
            if (this.attemptAuthorizations.length === 1) {
                return `${this.attemptAuthorizations[0].name}`;
            }
            return `${this.attemptAuthorizations[0].name} and ${this.attemptAuthorizations.length - 1} others`;
        },

        anyExpiring() {
            return this.attemptAuthorizations.some(attemptAuthorization => attemptAuthorization.expires_at !== null);
        },

        noneExpiring() {
            return this.attemptAuthorizations.every(attemptAuthorization => attemptAuthorization.expires_at === null);
        },

        soonestExpiring() {
            return this.attemptAuthorizations.reduce((previous, current) => {
                if (current.expires_at !== null && (previous === null || current.expires_at < previous.expires_at)) {
                    return current;
                }
                return previous;
            }, null);
        },
    },
};
</script>
